import { useEffect } from "react";
import { LicenseDetails, LicenseService } from "../../licensing/LicenseService";
import { useAsync } from "../hooks/useAsync";

export { useLicenseDetails };

function useLicenseDetails(): [LicenseDetails | undefined, boolean] {
  const [licenseDetails, getLicenseDetails, loadingLicenseDetails] = useAsync(
    () => LicenseService.getLicenseDetails(),
    undefined,
  );
  useEffect(() => getLicenseDetails(), []);
  return [licenseDetails, loadingLicenseDetails];
}
